import { SessionService } from './session/shared/session/session-service/session.service';
import { throwError } from 'rxjs';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { PersonalLoansSessionDataModel } from '@app/shared/services/session';

export abstract class ApiService {
  protected get authToken(): string {
    return this.sessionService.data.authData.token;
  }

  protected get plData(): PersonalLoansSessionDataModel {
    return this.sessionService.personalLoanSession.data;
  }

  constructor(protected sessionService: SessionService) {}

  protected apiErrorHandler(err): ErrorObservable<any> {
    console.error(err);
    return throwError(err);
  }
}
